export const fileToBase64 = (file, withPrefix = false) => {
  if (!(file instanceof Blob)) return null;

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      try {
        if (withPrefix) {
          resolve(reader.result); // ✅ з data:image/...;base64,
        } else {
          resolve(reader.result.split(",")[1]); // старий режим
        }
      } catch (error) {
        reject(new Error(`Failed to parse Base64: ${error.message}`));
      }
    };

    reader.onerror = error =>
      reject(new Error(`FileReader error: ${error.message}`));

    reader.readAsDataURL(file);
  });
};
